import { useTranslation } from 'react-i18next';
import { Chip, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { RangePlanningItem } from '../types';

interface InventoryMappingTabProps {
  item: RangePlanningItem;
}

const InventoryMappingTab = ({ item }: InventoryMappingTabProps) => {
  const { t } = useTranslation('rangePlanningItems');

  if (item.inventoryMapping.length === 0) {
    return (
      <Paper variant="outlined"
        sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {t('noInventoryMapping', 'No warehouse/inventory mapping recorded for this item.')}
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('warehouseCode', 'Warehouse')}</TableCell>
            <TableCell>{t('binLocation', 'Bin Location')}</TableCell>
            <TableCell align="right">{t('onHandQty', 'On Hand Qty')}</TableCell>
            <TableCell align="right">{t('reorderPoint', 'Reorder Point')}</TableCell>
            <TableCell>{t('statusLabel', 'Status')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {item.inventoryMapping.map((mapping) => {
            const belowReorder = mapping.onHandQty < mapping.reorderPoint;
            return (
              <TableRow key={`${mapping.warehouseCode}-${mapping.binLocation}`}>
                <TableCell>{mapping.warehouseCode}</TableCell>
                <TableCell>{mapping.binLocation}</TableCell>
                <TableCell align="right">{mapping.onHandQty}</TableCell>
                <TableCell align="right">{mapping.reorderPoint}</TableCell>
                <TableCell>
                  <Chip
                    label={belowReorder ? t('belowReorderPoint', 'Below reorder point') : t('inStock', 'In stock')}
                    color={belowReorder ? 'warning' : 'success'}
                    size="small"
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default InventoryMappingTab;
